'use client';

import { RootLoading } from '@workspace/ui';
import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';

export default function PermissionsProvider({
  children,
  permissionMap,
}: {
  children: React.ReactNode;
  permissionMap: Record<string, number>;
}) {
  const setPermissionMap = useAuthStore((s) => s.setPermissionMap);
  const isPermissionMapLoaded = useAuthStore((s) => s.isPermissionMapLoaded);

  useEffect(() => {
    setPermissionMap(permissionMap);
  }, [permissionMap, setPermissionMap]);

  if (!isPermissionMapLoaded) {
    return <RootLoading />;
  }

  return children;
}
